import React, { createContext, useContext } from 'react';

export interface FrenchState {
    isFrenchChecked: boolean;
  }
  
 export interface FrenchAction {
    type: 'TOGGLE_FRENCH';
  }
  
 export const frenchReducer = (state: FrenchState, action: FrenchAction): FrenchState => {
    switch (action.type) {
      case 'TOGGLE_FRENCH':
        return { ...state, isFrenchChecked: !state.isFrenchChecked };
      default:
        return state;
    }
  };
  
  export const FrenchContext = createContext<[FrenchState, React.Dispatch<FrenchAction>] | undefined>(undefined);

  export const useFrench = (): [FrenchState, React.Dispatch<FrenchAction>] => {
    const context = useContext(FrenchContext);
    if (!context) {
      throw new Error('useFrench must be used within a FrenchProvider');
    }
    return context;
  };
  